import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Send, Bot, User } from "lucide-react";
import { MarkdownMessage } from "./MarkdownMessage";

const BOUNCE_DELAYS = ["0ms", "150ms", "300ms"];

const Avatar = ({ role }) =>
  role === "assistant"
    ? <div className="p-2 bg-ism-teal/10 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0"><Bot className="h-5 w-5 text-ism-teal" /></div>
    : <div className="p-2 bg-white/10 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0"><User className="h-5 w-5 text-white" /></div>;

const MessageRow = ({ message, idx }) => {
  const mine = message.role === "user";
  return (
    <div className={`flex gap-3 ${mine ? "justify-end" : "justify-start"}`} data-testid={`message-${idx}`}>
      {!mine && <Avatar role="assistant" />}
      <div className={`max-w-[80%] rounded-lg p-4 ${mine ? "bg-ism-teal text-white" : "bg-white/5 text-gray-300"}`}>
        {mine
          ? <p className="text-sm leading-relaxed whitespace-pre-wrap">{message.content}</p>
          : <MarkdownMessage text={message.content} testId={`message-${idx}-markdown`} />}
      </div>
      {mine && <Avatar role="user" />}
    </div>
  );
};

const TypingIndicator = () => (
  <div className="flex gap-3 justify-start">
    <Avatar role="assistant" />
    <div className="bg-white/5 rounded-lg p-4">
      <div className="flex gap-2">
        {BOUNCE_DELAYS.map((delay) => <div key={delay} className="w-2 h-2 bg-ism-teal rounded-full animate-bounce" style={{ animationDelay: delay }} />)}
      </div>
    </div>
  </div>
);

export const AdvisorChat = ({ messages, input, setInput, loading, scrollRef, onSend }) => (
  <Card className="glass-card rounded-xl h-[700px] flex flex-col">
    <ScrollArea className="flex-1 p-6" ref={scrollRef}>
      <div className="space-y-4">
        {messages.map((m, idx) => <MessageRow key={m.id || `${m.role}-${idx}`} message={m} idx={idx} />)}
        {loading && <TypingIndicator />}
      </div>
    </ScrollArea>
    <div className="p-4 border-t border-gray-800">
      <div className="flex gap-2">
        <Input value={input} onChange={(e) => setInput(e.target.value)} onKeyPress={(e) => e.key === "Enter" && !loading && onSend()}
          placeholder="Ask me anything about your sales strategy..." className="bg-white/5 border-gray-700 text-white" disabled={loading} data-testid="advisor-input" />
        <Button onClick={onSend} disabled={loading || !input.trim()} className="bg-ism-teal hover:bg-ism-teal/90 text-white" data-testid="advisor-send-btn">
          <Send className="h-4 w-4" />
        </Button>
      </div>
    </div>
  </Card>
);
